import styled from 'styled-components';

import { media } from '../../utils/mediaQueries';

export const ImagePreviewWrapper = styled.div`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100px;
    height: 40px;
    padding: 10px 5px;

    img {
        width: auto;
        max-height: 40px;
        min-height: 40px;
        object-fit: cover;
    }
`;

export const TableWrapper = styled.div`
    border-radius: 0px;
    padding: 24px 0;

    .next-ui-table {
        border-radius: 0;
    }

    ${media.mobile} {
        padding: 12px 0;

        table {
            display: none;
        }
    }
`;

export const MobileCardList = styled.div`
    display: none;

    ${media.mobile} {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }
`;

export const MobileCard = styled.div`
    background: ${({ theme }) => (theme.mode === 'dark' ? '#1a1f26' : '#ffffff')};
    border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#dcdfe4')};
    border-radius: 6px;
    padding: 14px;
`;

export const MobileCardHeader = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 12px;
`;

export const MobileCardInfo = styled.div`
    flex: 1;
    min-width: 0;
`;

export const MobileCardTitle = styled.div`
    font-size: 14px;
    font-weight: 300;
    color: ${({ theme }) => theme.colors.text.primary};
    margin-bottom: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
`;

export const MobileCardDescription = styled.div`
    font-size: 12px;
    color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#6b7280')};
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 1.4;
`;

export const MobileCardFooter = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#f3f4f6')};
`;

export const MobileCardActions = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const TableActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
`;

export { IconActionButton as ActionButton } from '@/components/Buttons/ActionButton';

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : theme.colors.border.primary)};
`;

export const EmptyState = styled.div`
  padding: 60px 20px;
  text-align: center;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : theme.colors.text.secondary)};
  font-size: 15px;
`;
